<template>
  <div class="blockly">
    <div id="blocklyDiv"></div>
    <xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
    <category name="Motion" id="motLabel"  expanded="true" colour="%{BKY_MATH_HUE}">
        <!--行走-->
       <block type="dev_step">
        <value name="step">
          <block type="math_number">
            <field name="NUM">1</field>
          </block>
        </value>
        </block>
        <sep gap="5"></sep>
        <!-- <sep gap="5"></sep>
        <block type="dev_turn_left"></block>-->
        <sep gap="5"></sep>

        <!--右转-->
        <block type="dev_turn_right"></block>
        <sep gap="5"></sep>
        <!--飞船前进-->
        <block type="airship_step">
          <value name="step">
            <block type="math_number">
              <field name="NUM">1</field>
            </block>
          </value>
        </block>

        <sep gap="5"></sep>
        <!--飞船右转-->
        <block type="airship_turn_right"></block>
        <sep gap="5"></sep>
        <block type="window_wait"></block>
    </category>
    <category name="Control"  id="conLabel"  colour="%{BKY_LOOPS_HUE}">

        <!--重复执行-->
        <block type="controls_repeat_ext">
          <value name="TIMES">
            <block type="math_number">
              <field name="NUM">10</field>
            </block>
          </value>
        </block>
        <sep gap="5"></sep>
        <block type="controls_if"></block>
        <sep gap="5"></sep>
        <!-- <block type="controls_whileUntil"></block> -->
        <block type="logic_compare"></block>
        <sep gap="5"></sep>
        <block type="logic_operation"></block>
    </category>
    <category name="Num & Var" id="numLabel"  colour="%{BKY_VARIABLES_HUE}">
        <block type="variables_set">
          <field name="VAR">a</field>
        </block>
        <sep gap="5"></sep>
        <block type="variables_set">
          <field name="VAR">b</field>
        </block>

        <sep gap="5"></sep>
        <block type="math_change">
          <field name="VAR">a</field>
        </block>
        <sep gap="5"></sep>
        <block type="math_change">
          <field name="VAR">b</field>
        </block>

        <!--数字-->
        <block type="math_number">
          <field name="NUM">1</field>
        </block>
        <sep gap="5"></sep>
        <block type="variables_get">
          <field name="VAR">a</field>
        </block>
        <sep gap="5"></sep>
        <block type="variables_get">
          <field name="VAR">b</field>
        </block>
        <sep gap="5"></sep>
        <block type="math_arithmetic">
          <value name="A">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="B">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
        </block>


      </category>
      <category name="Functions" id="funLabel" custom="PROCEDURE" colour="%{BKY_LOOPS_HUE}">
      </category>
    </xml>

     <xml xmlns="https://developers.google.com/blockly/xml" id="toolbox_block" style="display: none">
        <!--行走-->
       <block type="dev_step">
        <value name="step">
          <block type="math_number">
            <field name="NUM">1</field>
          </block>
        </value>
      </block>
      <sep gap="5"></sep>
      <!-- <sep gap="5"></sep>
      <block type="dev_turn_left"></block>-->
      <sep gap="5"></sep>

      <!--右转-->
      <block type="dev_turn_right"></block>
      <sep gap="5"></sep>
      <!--飞船前进-->
      <block type="airship_step">
        <value name="step">
          <block type="math_number">
            <field name="NUM">1</field>
          </block>
        </value>
      </block>

      <sep gap="5"></sep>
      <!--飞船右转-->
      <block type="airship_turn_right"></block>
      <sep gap="5"></sep>
      <!--重复执行-->
      <block type="controls_repeat_ext">
        <value name="TIMES">
          <block type="math_number">
            <field name="NUM">10</field>
          </block>
        </value>
      </block>
      <sep gap="5"></sep>
      <block type="variables_set">
        <field name="VAR">a</field>
      </block>
      <sep gap="5"></sep>
      <block type="variables_set">
        <field name="VAR">b</field>
      </block>

      <sep gap="5"></sep>
       <block type="math_change">
        <field name="VAR">a</field>
      </block>
      <sep gap="5"></sep>
      <block type="math_change">
        <field name="VAR">b</field>
      </block>

      <!--数字-->
      <block type="math_number">
        <field name="NUM">1</field>
      </block>
      <sep gap="5"></sep>
      <block type="variables_get">
        <field name="VAR">a</field>
      </block>
      <sep gap="5"></sep>
      <block type="variables_get">
        <field name="VAR">b</field>
      </block>
      <sep gap="5"></sep>
      <block type="math_arithmetic">
        <value name="A">
          <shadow type="math_number">
            <field name="NUM">1</field>
          </shadow>
        </value>
        <value name="B">
          <shadow type="math_number">
            <field name="NUM">1</field>
          </shadow>
        </value>
      </block>
      <sep gap="5"></sep>
      <!-- <block type="controls_whileUntil"></block> -->
      <block type="controls_if"></block>
      <sep gap="5"></sep>
      <block type="logic_compare"></block>
      <sep gap="5"></sep>
      <block type="logic_operation"></block>
      <sep gap="5"></sep>
      <block type="window_wait"></block>
      <!-- <block type="controls_whileUntil"></block>
      <sep gap="5"></sep>-->
      <!-- <block type="flyer_disapper"></block>
      <sep gap="5"></sep>-->
      <!-- <sep gap="5"></sep> -->
      <!-- <block type="dev_energy"></block> -->
      <!-- <button text="create variable" callbackKey="CREATE_VARIABLE"></button> -->
    </xml>

    <div class="pointerTxt">{{lang == 'en'? blocklyText.en :(lang=="he"? blocklyText.he: blocklyText.zh)}}</div>

    <div class='audioBlockly' v-show="audioOpenShow" :style="{backgroundImage: 'url('+createURL+'/static/images/audio/' + lang + '/sign03.png)',backgroundSize:'contain'}"></div>
    <div class="blocklyP">
      <div
        class="blocklyL"
        :style="{background: 'url(' + allImageMap.blocklyL + ') no-repeat',backgroundSize:'contain'}"
      ></div>
      <div
        class="blocklyR"
        :style="{background: 'url(' + allImageMap.blocklyR + ') no-repeat',backgroundSize:'contain'}"
      >
        <div
          class="runCode"
          @click="runCode()"
          @mouseover="runCodeShow(false)"
          v-if="runShow"
          :style="{background: 'url(' + allImageMap.run01 + ') no-repeat',backgroundSize:'contain'}"
        ></div>
        <div
          class="runCode"
          @click="runCode()"
          @mouseleave="runCodeShow(true)"
          v-if="!runShow"
          :style="{background: 'url(' + allImageMap.run02 + ') no-repeat',backgroundSize:'contain'}"
        ></div>
		<div class="mobile-btn">
        <div
          class="openAudio"
          ref="audio01"
          :style="{background: 'url(' + allImageMap.audio002 + ')'}"
          @click="checkAudioOpen()"
          v-show="!blocklyAudioShow"
        ></div>
        <div
          class="openAudio"
          ref="audio02"
          :style="{background: 'url(' + allImageMap.audio001 + ')'}"
          @click="checkAudioClose()"
          v-show="blocklyAudioShow"
        ></div>
        <div
          class="resetBtn"
          ref="blocklyQuestionMark"
          @click="resetCodeHandler"
          :style="{background: 'url(' + allImageMap.block_reset + ')'}"
        ></div>
        <div
          class="opreate01"
          ref="blocklyQuestionMark"
          @click="checkImg"
          :style="{background: 'url(' + allImageMap.op01 + ')'}"
        ></div>
		</div>
      </div>
      <div
        class="blocklyC"
        @mouseenter="blocklyTextShow('1')"
        @mouseleave="blocklyTextShow('0')"
        :style="{background: 'url(' + allImageMap.blocklyC + ') repeat',backgroundSize:'contain'}"
      >
        <span v-show="lang=='zh'">{{blocklyText.zh}}</span>
        <span v-show="lang=='en'">{{blocklyText.en}}</span>
        <span v-show="lang=='he'">{{blocklyText.he}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import store from "../../store";
import { mapGetters } from "vuex";
import AdventureManager from "../../manager/AdventureManager";
import OperateDom from "../../manager/OperateDom";
export default {
  data() {
    return {
      blocklyAudioShow: false,
      runShow: true,
      createURL: process.env.GAME_CREATE_URL,
      startScale: 1,
      maxScale: 1.6,
      minScale: 0.7,
      audioOpenShow:true,
    };
  },
  mounted() {
    // 自定义方法挂载全局 方便测试使用
    window["test_show_blockly"] = (data = '') => {
      AdventureManager.toFront_importCode(data)
      $("#runCode").click();
    };
    // 判断用户使用设备
    let os = (function() {
      let ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet =
          /(?:iPad|PlayBook)/.test(ua) ||
          (isAndroid && !/(?:Mobile)/.test(ua)) ||
          (isFireFox && /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian;
      return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc
      };
    })();

    if (os.isAndroid || os.isPhone || os.isTablet) {
      // $("#boxide_lefts").css("width", "500px");
      // $(".blockly").css({ width: "calc(100% - 500px)", left: "500px" });
	  var ideWidth = window.innerWidth / 3.5;
	  $("#boxide_lefts").css("width", ideWidth + "px")
      $(".blockly").css({ width: "calc(100% - " + ideWidth + "px)", left: ideWidth + "px" });

      $("#blocklyDiv").css("width", "100%");
      $(".blocklyL").css({
        "background-position-x": "-117px",
        "background-size": "cover"
      });
      $(".blocklyC").css({
        "min-width": "144px",
        left: "68px",
        width: "calc(100% - 380px)"
      });
    }
    let zoomRatio = AdventureManager.changeRatio();
    let screenHeight = document.body.clientHeight;
    if (zoomRatio == "150" || zoomRatio == "125" || screenHeight < 800) {
      this.startScale = 0.7;
      this.minScale = 0.3;
      this.maxScale = 1.3;
    }
    let gameId = this.$route.query.game;
    // alert(gameId);
    // alert(store.state.checkLangs);
    let languageData = sessionStorage.getItem("Lanauge");
    if(languageData==null||languageData=="zh"){
      document.getElementById("numLabel").setAttribute("name","数与变量");
      document.getElementById("motLabel").setAttribute("name","运动");
      document.getElementById("conLabel").setAttribute("name","控制");
      document.getElementById("funLabel").setAttribute("name","函数");
    }
    let workspace = Blockly.inject("blocklyDiv", {
      media: "../../../static/media/",
      toolbox: this.neeShowFun(gameId)?document.getElementById("toolbox"):document.getElementById("toolbox_block"),//2034、2035、2036、2038
      zoom: {
        controls: true,
        wheel: false,
        startScale: this.startScale,
        maxScale: this.maxScale,
        minScale: this.minScale,
        scaleSpeed: 1.2
      },
      grid: { spacing: 20, length: 3, colour: "#ccc", snap: true }, //网格模式
      trashcan: true,
      scrollbars: true
    });
    store.state.Workspace = workspace;

    workspace.scrollCenter()
    console.log("我是blockly实例对象===", store.state.Workspace);
  },
  methods: {
    neeShowFun(gameId){
      if(gameId==202102){
        return true;
      }
      if(gameId==2034){
        return true;
      }
      if(gameId==2035){
        return true;
      }
      if(gameId==2036){
        return true;
      }
      if(gameId==2038){
        return true;
      }
      if(gameId==2021201){
        return true;
      }
      if(gameId==2021302){
        return true;
      }
      return false;
    },
    resetCodeHandler(){
      store.state.toBack = true;
      store.state.skipStyleShow = false
      AdventureManager.sendToGame("showResetCodeDialog");
    },
    runCode() {
      // console.log("store.state.Workspace",store.state.Workspace.getTopBlocks());
      // console.log(Blockly.Xml.workspaceToDom(store.state.Workspace));
      // 检查是否嵌套太多
      let list = store.state.Workspace.getTopBlocks();
      // let xml = Blockly.Xml.workspaceToDom(store.state.Workspace);
      // console.log("domToPrettyText1",Blockly.Xml.domToPrettyText(xml))
      for(var i=0;i<list.length;i++){
        this.checkIsMax({"block":list[i],"len":0});
      }
      // console.log("domToPrettyText",Blockly.Xml.domToPrettyText(xml))
      this.audioOpenShow = false;
      if(window._code_is_running) return;
      AdventureManager.getWorkspaceCode();
      window.LoopTrap = 1000;
      Blockly.JavaScript.INFINITE_LOOP_TRAP =
        'if (--window.LoopTrap == 0) throw "Infinite loop.";\n';

      var code = Blockly.JavaScript.workspaceToCode(store.state.Workspace);
      var pythonCode = Blockly.Python.workspaceToCode(store.state.Workspace);
      console.log("PythonCode:", pythonCode);
      console.log("JavaScriptCode:", code);
      window._code_is_running = true;
      window.bridge.clearCurrentSteps();
      Blockly.JavaScript.INFINITE_LOOP_TRAP = null;
      try {
        eval(code);
      } catch (e) {
        alert(e);
      }
      window.bridge.onRunCodeButtonClick();
    },
    checkIsMax(parentBlock){
      if(parentBlock.len>12){
        alert("嵌套太多");
        throw new Error("嵌套太多");
      }
      let list = parentBlock.block.getChildren();
      for(var i = 0;i<list.length;i++){
        if(list[i]==parentBlock.block.getNextBlock()){
          this.checkIsMax({"block":list[i],"len":0})
          continue;
        }
        this.checkIsMax({"block":list[i],"len":parentBlock.len+1});
      }
    },

    runCodeShow(flag) {
      this.runShow = flag;
    },
    // 开关背景音乐
    checkAudioOpen() {
      this.blocklyAudioShow = true;
      window.bridge.toggleMusic(1);
    },
    checkAudioClose() {
      this.blocklyAudioShow = false;
      window.bridge.toggleMusic(0);
    },
    checkImg() {
      setTimeout(() => {
        store.state.imgList = [];
        if (
          window.bridge.getHelpImageData() == undefined ||
          !window.bridge.getHelpImageData()
        )
          return;
        let arr = window.bridge.getHelpImageData(),
          arr1 = [];
        for (var i in arr) arr1.push(arr[i].image);
        let imgageUrl =
          this.createURL + "/static/images/operate/" + store.state.lang + "/";
        for (var j in arr1) store.state.imgList.push(imgageUrl + arr1[j]);
        store.state.imgShow = true;
      }, 500);
    },
    blocklyTextShow(op) {
      $(".pointerTxt").css("opacity", op);
      let st = op == "1" ? "block" : "none";
      $(".pointerTxt").css("display", st);
    }
  },
  computed: {
    ...mapGetters(["Workspace", "allImageMap", "lang", "blocklyText"])
  }
};
</script>
<style scoped>
.blockly {
  box-sizing: border-box;
  width: calc(100% - 640px);
  height: 100%;
  font-size: 50px;
  position: relative;
  background: #fff4e5;
  left: 640px;
  top: 0;
}
#blocklyDiv {
  width: 100%;
  height: calc(100% - 150px);
  position: absolute;
}
.blocklyP {
  height: 150px;
  width: 100%;
  position: absolute;
  bottom: 0px;
  left: 0;
  overflow: hidden;
}
.blocklyP .blocklyL {
  width: 189px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.blocklyP .blocklyR {
  width: 274px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
}
.blocklyC {
  width: calc(100% - 497px);
  height: calc(100% - 50px);
  position: absolute;
  right: 272px;
  top: 0;
  font-size: 20px;
  color: #fff;
  padding: 25px 20px;
  line-height: 25px;
  min-width: 100px !important;
  cursor: pointer;
}
.blocklyC span {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
.blocklyR .runCode {
  position: absolute;
  width: 162px;
  height: 60px;
  left: 68px;
  top: 22px;
  cursor: pointer;
}
.openAudio {
  position: absolute;
  width: 42px;
  height: 42px;
  left: 74px;
  top: 88px;
  cursor: pointer;
  transition: all 0.3s ease-in-out 0s;
  transform: scale(1);
}
.resetBtn {
  position: absolute;
  width: 42px;
  height: 42px;
  right: 103px;
  top: 88px;
  cursor: pointer;
  transition: all 0.3s ease-in-out 0s;
  transform: scale(1);
}
.resetBtn:hover,
.resetBtn:hover {
  transform: scale(1.1);
}
.opreate01 {
  position: absolute;
  width: 42px;
  height: 42px;
  right: 49px;
  top: 88px;
  cursor: pointer;
  transition: all 0.3s ease-in-out 0s;
  transform: scale(1);
}
.openAudio:hover,
.opreate01:hover {
  transform: scale(1.1);
}
.pointerTxt {
  position: absolute;
  bottom: 170px;
  font-size: 14px;
  color: #223952;
  left: 200px;
  padding-right: 90px;
  transition: all 0.3s ease-in-out 0s;
  opacity: 0;
}
 .audioBlockly{
    position:absolute;
    bottom:0px;
    margin-bottom: 120px;
    right: 70px;
    width: 150px;
    height: 162px;
    z-index:91111;
    animation: firstdiv .5s linear .5s infinite alternate;
  }
@media (max-height: 420px) and (orientation: landscape) {
	#blocklyDiv {
	  height: calc(100% - 70px);
	}
	.blocklyP {
	  height: 70px;
	}
	.blocklyR {
	  background-size: cover !important;
	}
	.blocklyP .blocklyL {
	  background-position: 0 0 !IMPORTANT;
	}
	.blocklyC {
	    left: 68px !important;
		width: calc(100% - 368px) !important;
		background: #a7cef9 !important;
		top: 0;
		border-top: 5px solid #fafafa;
	}
	.blocklyC span {
	 	display: none;
	}
	.blocklyP .blocklyR {
		top: 1px;
		width: 260px;
	}
	.blocklyR .runCode {
	    position: absolute;
	    width: 162px;
	    height: 50px;
	    left: 84px;
	    top: 19px;
	    cursor: pointer;
		transform: scale(.9);
	}
	.openAudio {
		top: 0;
	}
	.resetBtn {
		top: 0;
	}
	.opreate01 {
		top: 0;
	}
	.audioBlockly {
	    margin-bottom: 55px;
	    right: 70px;
	    width: 100px;
	    height: 100px;
	}
	.mobile-btn {
	    position: fixed;
	    height: 60px;
	    width: 270px;
	    z-index: 9;
	    right: 0;
	    bottom: -10px;
	    transform: translateX(-65%);
	}
}
</style>



// WEBPACK FOOTER //
// src/components/onlineClass/blockly.vue